export enum ButtonTypeEnum {
  BASIC = 'basic',
  SUCCESS = 'success',
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'danger',
  INFO = 'info'
}
